import { VendorDiscount } from '@buyiq-core/models/vendor-discount';
import { DefaultOrderUnit } from '@buyiq-core/models/legacy-vendor';

export class VendorInfo {
    legacyVendorId: number;
    partitionEnabled: boolean;
    discounts: Array<VendorDiscount>;
    defaultOrderUnit?: DefaultOrderUnit;

    constructor(options?: Partial<VendorInfo>) {
        Object.assign(this, options);
    }
}
